export default __webpack_public_path__ + "static/media/fashion_model.a0738879.png";